/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const ZodiacPisces = createLucideIcon("zodiac-pisces", [
  ["path", { d: "M19 21a15 15 0 0 1 0-18", key: "br2vug" }],
  ["path", { d: "M20 12H4", key: "1mtusc" }],
  ["path", { d: "M5 3a15 15 0 0 1 0 18", key: "1w7hae" }]
]);

export { ZodiacPisces as default };
//# sourceMappingURL=zodiac-pisces.js.map
